<template>
    <a class="comment"  target="_blank" :href="`https://reddit.com${post.permalink}?context=3`">
        <div class="score">{{post.score}}</div>
        <ellipsis
                :line-clamp="3"
                :data="post.body"
                class="text"
                end-char="..."
        />
    </a>
</template>

<script>
    export default {
        props: {
            post: Object

        },
        computed:{
        }

    }
</script>

<style lang="scss" scoped>
    .comment {
        display: grid;
        grid-template-columns: auto 1fr;
        background: #37373b;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
        border-radius: 2px;
        text-shadow: none;
        color: rgba(250, 250, 250, 0.6);

        &:hover{
            background: #444;
            .text {
                background: #555;
            }
        }

        .score {
            align-self: center;
            text-align: center;
            width: 50px;
        }

        .text {
            color:white;
            background: #444;
            padding:.8em;
            border-bottom:1px solid rgba(200,200,200,.2);
        }
    }

</style>